import { render, staticRenderFns } from "./newSafetyEducation.vue?vue&type=template&id=73119e3d&scoped=true&"
import script from "./newSafetyEducation.vue?vue&type=script&lang=js&"
export * from "./newSafetyEducation.vue?vue&type=script&lang=js&"
import style0 from "./newSafetyEducation.vue?vue&type=style&index=0&id=73119e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73119e3d",
  null
  
)

export default component.exports